import { get } from 'lodash';

export const getSiteProperties = state => state.siteProperties;
export const getBusinessName = state => get(getSiteProperties(state), 'businessName', '');
export const getLogo = state => get(getSiteProperties(state), 'logo', '');
